import React from 'react';

import { ActiveChatProvider } from '@hooks/useActiveChat';
import { AssignTaskNudgeProvider } from '@hooks/useAssignTaskNudge';
import { ChatInputProvider } from '@hooks/useChatInput';
import { ChatNudgeProvider } from '@hooks/useChatNudge';
import { ChatProcessingProvider } from '@hooks/useChatProcessing';
import { ChatTutorialProvider } from '@hooks/useChatTutorial';
import { ChatTutorialWebProvider } from '@hooks/useChatTutorialWeb';
import { ChatUploadManagerProvider } from '@hooks/useChatUploadManager';
import { ContactsProvider } from '@hooks/useContacts';
import { DownloadFilesProvider } from '@hooks/useDownloadFiles';
import { EmojiProvider } from '@hooks/useEmoji';
import { FeatureFlagProvider } from '@hooks/useFeatureFlag';
import { GlobalSearchProvider } from '@hooks/useGlobalSearch';
import { GlobalSearchProviderProject } from '@hooks/useGlobalSearchProjects';
import { InviteMemberNudgeProvider } from '@hooks/useInviteMemberNudge';
import { MeProvider } from '@hooks/useMe';
import { MemberTaskNudgeProvider } from '@hooks/useMemberTaskNudge';
import { NotificationProvider } from '@hooks/useNotification';
import { OwnerNudgeProvider } from '@hooks/useOwnerNudge';
import { PreviewDocumentsProvider } from '@hooks/usePreviewDocuments';
import { ProjectOnboardingProvider } from '@hooks/useProjectOnboarding';
import { ProjectsFilterProvider } from '@hooks/useProjectsFilter';
import { ProjectTaskFilterProvider } from '@hooks/useProjectTaskFilter';
import { ProjectTutorialProvider } from '@hooks/useProjectTutorial';
import { ProjectTutorialWebProvider } from '@hooks/useProjectTutorialWeb';
import { RateAppPromptProvider } from '@hooks/useRateAppPrompt';
import { RevenueCatProvider } from '@hooks/useRevenueCat';
import { SearchProvider } from '@hooks/useSearch';
import { SelectedMembersProvider } from '@hooks/useSelectedMembers';
import { TabFocusProvider } from '@hooks/useTabFocus';
import { TagInputProvider } from '@hooks/useTagInput';
import { TaskProvider } from '@hooks/useTask';
import { TaskCreateFooterProvider } from '@hooks/useTaskCreateFooter';
import { TaskNudgeProvider } from '@hooks/useTaskNudge';
import { TasksFilterProvider } from '@hooks/useTasksFilter';
import { UploadFilesProvider } from '@hooks/useUploadFiles';
import { UsersProvider } from '@hooks/useUsers';

export const CoreProviders = ({ children }: { children: React.ReactNode }) => (
  <MeProvider>
    <OwnerNudgeProvider>
      <InviteMemberNudgeProvider>
        <ChatNudgeProvider>
          <TaskNudgeProvider>
            <AssignTaskNudgeProvider>
              <MemberTaskNudgeProvider>
                <ProjectOnboardingProvider>
                  <ChatTutorialWebProvider>
                    <ChatTutorialProvider>
                      <ProjectTutorialProvider>
                        <ProjectTutorialWebProvider>
                          <FeatureFlagProvider>
                            <TabFocusProvider>
                              <GlobalSearchProvider>
                                <GlobalSearchProviderProject>
                                  <TagInputProvider>
                                    <PreviewDocumentsProvider>
                                      <ActiveChatProvider>
                                        <NotificationProvider>
                                          <SearchProvider>
                                            <ChatUploadManagerProvider>
                                              <ChatInputProvider>
                                                <RateAppPromptProvider>
                                                  <ChatProcessingProvider>
                                                    <UsersProvider>
                                                      <ContactsProvider>
                                                        <DownloadFilesProvider>
                                                          <UploadFilesProvider>
                                                            <ProjectsFilterProvider>
                                                              <TasksFilterProvider>
                                                                <ProjectTaskFilterProvider>
                                                                  <TaskProvider>
                                                                    <SelectedMembersProvider>
                                                                      <EmojiProvider>
                                                                        <RevenueCatProvider>
                                                                          <TaskCreateFooterProvider>
                                                                            {
                                                                              children
                                                                            }
                                                                          </TaskCreateFooterProvider>
                                                                        </RevenueCatProvider>
                                                                      </EmojiProvider>
                                                                    </SelectedMembersProvider>
                                                                  </TaskProvider>
                                                                </ProjectTaskFilterProvider>
                                                              </TasksFilterProvider>
                                                            </ProjectsFilterProvider>
                                                          </UploadFilesProvider>
                                                        </DownloadFilesProvider>
                                                      </ContactsProvider>
                                                    </UsersProvider>
                                                  </ChatProcessingProvider>
                                                </RateAppPromptProvider>
                                              </ChatInputProvider>
                                            </ChatUploadManagerProvider>
                                          </SearchProvider>
                                        </NotificationProvider>
                                      </ActiveChatProvider>
                                    </PreviewDocumentsProvider>
                                  </TagInputProvider>
                                </GlobalSearchProviderProject>
                              </GlobalSearchProvider>
                            </TabFocusProvider>
                          </FeatureFlagProvider>
                        </ProjectTutorialWebProvider>
                      </ProjectTutorialProvider>
                    </ChatTutorialProvider>
                  </ChatTutorialWebProvider>
                </ProjectOnboardingProvider>
              </MemberTaskNudgeProvider>
            </AssignTaskNudgeProvider>
          </TaskNudgeProvider>
        </ChatNudgeProvider>
      </InviteMemberNudgeProvider>
    </OwnerNudgeProvider>
  </MeProvider>
);
